import { HtmlId } from '../enum';

const NAVBAR_OFFSET = 50;

/**
 * Scroll given element into the viewport
 * @param {HtmlId} id - id of the element to scroll to
 * @param {number} threshold - number of pixels of the element that can be out of the viewport before scrolling
 * @returns {void}
 */
export const scrollTo = (id: HtmlId, threshold = 50) => {
    const form = document.getElementById(id);

    if (!form) {
        return;
    }

    const bounds = form.getBoundingClientRect();

    const isTopVisible = bounds.top + threshold > 0;
    const isBottomVisible = bounds.bottom - threshold < window.innerHeight;

    if (isTopVisible && isBottomVisible) {
        return;
    }

    window.scrollTo({
        top: bounds.top + window.scrollY - NAVBAR_OFFSET,
        behavior: 'smooth',
    });
};
